import * as React from 'react';
import { Box, Typography, Avatar, Grid, Skeleton, Stack } from '@mui/material';

export default function DashboardSkeleton() {
    const skeletons = [1, 2, 3, 4, 5]; // Array representing the number of skeletons

    return (
        <Grid container spacing={2} sx={{ width: '100%', margin: 0 }}>
            {skeletons.map((item, index) => (
                <Grid
                    item
                    key={index}
                    xs={12}
                    sm={6} // Items will occupy 50% width on small screens
                    md={4} // 3 items per row on medium screens (33% each)
                    sx={{ display: 'flex', justifyContent: 'center' }} // Center-aligning each grid item
                >
                    <Box
                        sx={{
                            width: '100%',
                            maxWidth: 300, // Ensure the width is equal for all boxes
                            height: "180px", // Ensure the height is equal for all boxes
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: 2,
                            boxSizing: 'border-box',
                            backgroundColor: '#f4f4f4',
                            borderRadius: 2,
                        }}
                    >
                        {/* Avatar Skeleton */}
                        <Stack direction="row" width="100%" justifyContent="space-between">
                            <Box >
                                <Skeleton variant="circular" sx={{ height: "60%", maxWidth: "60%" }}>
                                    <Avatar />
                                </Skeleton>

                            </Box>
                            <Box sx={{ width: '100%' }}>

                                <Skeleton width="100%"   >
                                    <Typography>.</Typography>
                                </Skeleton>

                            </Box>
                        </Stack>

                        {/* Rectangle Skeleton */}
                        <Skeleton variant="rectangular" width="100%" height="150px" />
                    </Box>
                </Grid>
            ))
            }
        </Grid >
    );
}
